var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"steps-item",class:{'steps-item--active': _vm.isActive}},[_c('span',{staticClass:"steps-item__number"}),_c('span',{staticClass:"steps-item__text"},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }